import { makeStyles } from '@material-ui/core'

import { Card, Heading } from 'app/ui'

import { joinStyles, various } from 'app/utils/theme'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: various.padding,
        [theme.breakpoints.up('sm')]: {
            width: '400px',
        },
    },

    group: {
        width: '100%',
    },

    information: {
        margin: '5px auto',
    },

    name: {
        fontWeight: 'bold',
    },
}))

type CardGlobalInformationProperties = {
    className?: string
    title: string
    informations: {
        name: string
        value: string | number
        className?: string
    }[]
}

/** Display global information. */
export const CardGlobalInformation = ({
    className,
    title,
    informations,
}: Readonly<CardGlobalInformationProperties>): JSX.Element => {
    const classes = useStyles()

    return (
        <Card className={joinStyles(classes.root, className)}>
            <Heading
                variant='h2'
                center
            >
                {title}
            </Heading>

            <div className={classes.group}>
                {informations.map((information) => (
                    <div
                        key={information.name}
                        className={classes.information}
                    >
                        <span className={classes.name}>
                            {`${information.name} : `}
                        </span>

                        <span className={joinStyles(information.className)}>
                            {information.value}
                        </span>
                    </div>
                ))}
            </div>
        </Card>
    )
}
